import { CCol } from '@coreui/react';
import React from 'react';

const BaseCol = React.memo(({ children, ...rest }) => {
  return <CCol {...rest}>{children}</CCol>;
});

export default BaseCol;
